import { Bot, FileUp, Globe, MessageSquare, Phone, UserPlus } from "lucide-react";
import { cn } from "@/lib/utils";

const sourceConfig: Record<
    string,
    { icon: typeof Phone; label: string; color: string; bgColor: string }
> = {
    VoiceBot: {
        icon: Phone,
        label: "Voice Bot",
        color: "text-green-700",
        bgColor: "bg-green-100",
    },
    "SMS-Inbound": {
        icon: MessageSquare,
        label: "SMS",
        color: "text-blue-700",
        bgColor: "bg-blue-100",
    },
    WebChat: {
        icon: Globe,
        label: "Web Chat",
        color: "text-purple-700",
        bgColor: "bg-purple-100",
    },
    Import: {
        icon: FileUp,
        label: "Imported",
        color: "text-orange-700",
        bgColor: "bg-orange-100",
    },
    Manual: {
        icon: UserPlus,
        label: "Manual",
        color: "text-gray-700",
        bgColor: "bg-gray-100",
    },
};

interface SourceBadgeProps {
    source?: string;
    botId?: string;
    size?: "sm" | "md";
    showLabel?: boolean;
    className?: string;
}

export const SourceBadge = ({
    source,
    botId,
    size = "md",
    showLabel = true,
    className,
}: SourceBadgeProps) => {
    if (!source) return null;

    const config = sourceConfig[source] || sourceConfig.Manual;
    const IconComponent = config.icon;

    const sizeClasses = {
        sm: "text-xs px-1.5 py-0.5",
        md: "text-xs px-2 py-1",
    };

    const iconSizeClasses = {
        sm: "w-3 h-3",
        md: "w-3.5 h-3.5",
    };

    return (
        <span
            className={cn(
                "inline-flex items-center gap-1 rounded-full font-medium",
                sizeClasses[size],
                config.bgColor,
                config.color,
                className
            )}
        >
            <IconComponent className={iconSizeClasses[size]} />
            {showLabel && <span>{config.label}</span>}
            {botId && <Bot className={cn(iconSizeClasses[size], "ml-0.5")} />}
        </span>
    );
};

export const getSourceLabel = (source?: string): string => {
    if (!source) return "Unknown";
    return sourceConfig[source]?.label || source;
};
